/**
 * Side-effect import: registers PAIR_NETWORKING suggestion renderers.
 */

import React from "react";
import { SuggestionType } from "@shared/schemas/suggestion-type.schemas";
import { isProfileBasedSuggestion } from "@shared/schemas/profile-based-suggestion.schemas";
import { SuggestionRendererRegistry } from "../suggestion-renderer.registry";
import { ProfileSuggestionDisplay } from "./ProfileSuggestionDisplay";
import type { Suggestion } from "@shared/schemas/suggestion.schemas";

SuggestionRendererRegistry.register(
  SuggestionType.PROFILE_BASED,
  (suggestion: Suggestion) => {
    if (!isProfileBasedSuggestion(suggestion)) {
      return null;
    }
    return React.createElement(ProfileSuggestionDisplay, { suggestion });
  },
);
